import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "Notice",
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 表格加载


    var loading = ref(false);
    var tableloading = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_tableloading; // 第一个table的初始化

    var tableData = ref([{}]);
    var totalNum = ref(0);
    var pageIndex = ref(1); // 获取表一

    function getTableOne() {
      return _getTableOne.apply(this, arguments);
    }

    function _getTableOne() {
      _getTableOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getNoticeList"]({
                  pageIndex: pageIndex.value,
                  pageSize: 10
                });

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                tableData.value = _toConsumableArray(data);
                totalNum.value = total;
                loading.value = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTableOne.apply(this, arguments);
    }

    getTableOne();

    function changPage(val) {
      pageIndex.value = val;
      getTableOne();
    } // 查看详情


    var getDetail = function getDetail(noticeId) {
      router.push({
        name: "noticeDetail",
        query: {
          noticeId: noticeId
        }
      });
    };

    return {
      tableloading: tableloading,
      loading: loading,
      tableData: tableData,
      totalNum: totalNum,
      pageIndex: pageIndex,
      changPage: changPage,
      getDetail: getDetail
    };
  }
});